const BackUpIcon = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="backup">
      <mask
        id="mask0_2576_54679"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="48"
      >
        <rect id="Bounding box" width="48" height="48" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2576_54679)">
        <path
          id="backup_2"
          d="M13 40C9.96667 40 7.375 38.95 5.225 36.85C3.075 34.75 2 32.1833 2 29.15C2 26.55 2.78333 24.2333 4.35 22.2C5.91667 20.1667 7.96667 18.8667 10.5 18.3C11.3333 15.2333 13 12.75 15.5 10.85C18 8.95 20.8333 8 24 8C27.9 8 31.2083 9.35833 33.925 12.075C36.6417 14.7917 38 18.1 38 22C40.3 22.2667 42.2083 23.2583 43.725 24.975C45.2417 26.6917 46 28.7 46 31C46 33.5 45.125 35.625 43.375 37.375C41.625 39.125 39.5 40 37 40H26C24.9 40 23.9583 39.6083 23.175 38.825C22.3917 38.0417 22 37.1 22 36V25.7L18.8 28.8L16 26L24 18L32 26L29.2 28.8L26 25.7V36H37C38.4 36 39.5833 35.5167 40.55 34.55C41.5167 33.5833 42 32.4 42 31C42 29.6 41.5167 28.4167 40.55 27.45C39.5833 26.4833 38.4 26 37 26H34V22C34 19.2333 33.025 16.875 31.075 14.925C29.125 12.975 26.7667 12 24 12C21.2333 12 18.875 12.975 16.925 14.925C14.975 16.875 14 19.2333 14 22H13C11.0667 22 9.41667 22.6833 8.05 24.05C6.68333 25.4167 6 27.0667 6 29C6 30.9333 6.68333 32.5833 8.05 33.95C9.41667 35.3167 11.0667 36 13 36H18V40H13Z"
          fill="#00CF83"
        />
      </g>
    </g>
  </svg>
)
export default BackUpIcon
